import React from 'react'
import Icon from 'project/Icon'
import CardTitle from 'components/CardTitle'
import ContentContainer from 'components/project/tables/ContentContainer'
import { kycNeedsVerifying } from 'common/services/useKycStatus'
import { useFlags } from '@flagsmith/flagsmith/react'
import useAddress from 'common/hooks/useAddress'
import GenerateLetterOfCertification from './GenerateLetterOfCertification'
import { useDefaultSubscription } from 'common/services/useDefaultSubscription'
import Tooltip from 'components/base/Tooltip'

type AddressCardProps = {
  className?: string
}

const AddressCard: React.FC<AddressCardProps> = ({ className }) => {
  const { hasMailPlan, subscriptionDetail } = useDefaultSubscription()
  const { feature_letter_of_certification } = useFlags([
    'feature_letter_of_certification',
  ])

  const needsVerify = kycNeedsVerifying(subscriptionDetail)
  const address = useAddress()
  const locationName = subscriptionDetail?.location?.name || 'The Hoxton Mix'

  if (!hasMailPlan) return null

  return (
    <div className={className}>
      <ContentContainer className='h-100'>
        <CardTitle icon='pin'>Addresses</CardTitle>
        <div className='fw-bold mb-3' style={{ fontSize: 20 }}>
          Your Business Address
        </div>
        <div className='d-flex align-items-center gap-3'>
          <div
            className='d-flex align-items-center justify-content-center flex-shrink-0'
            style={{
              backgroundColor: 'var(--bs-primary)',
              borderRadius: 18,
              height: 44,
              width: 44,
            }}
          >
            <Icon name='office' fill='white' />
          </div>
          <div>
            <h3 className='fw-bold mb-0'>
              {subscriptionDetail?.company?.legal_name || locationName}
            </h3>
            <div className='text-primary fs-16 fw-bold'>{address}</div>
          </div>
        </div>
        {feature_letter_of_certification.enabled && (
          <div className='mt-10'>
            <Tooltip
              content={
                needsVerify
                  ? 'We cannot provide this until you have verified your identity and proof of address'
                  : undefined
              }
            >
              <GenerateLetterOfCertification
                className='w-100'
                disabled={needsVerify}
              />
            </Tooltip>
          </div>
        )}
      </ContentContainer>
    </div>
  )
}

export default AddressCard
